/* Loaded only when the launch setting is explicitly enabled. No automatic add retries. */
(function () {
  const core = window.C701GiftBoxCore;
  const config = document.querySelector('[data-c701-cart-config]');
  if (!core || !config || config.dataset.enabled !== 'true') return;
  const root = window.Shopify?.routes?.root || '/';
  const readCart = async () => {
    const response = await fetch(`${root}cart.js`, { cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error('Your cart could not be checked. Please try again.');
    return response.json();
  };
  const readStock = async () => {
    const response = await fetch(`${root}collections/single-wick-candles?section_id=c701-gift-stock`, { cache: 'no-store', credentials: 'same-origin' });
    if (!response.ok) throw new Error('Available scents could not be checked. Please refresh and try again.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = doc.querySelector('[data-c701-gift-stock]');
    if (!data) throw new Error('Available scents could not be checked. Please refresh and try again.');
    return JSON.parse(data.textContent).scents;
  };
  window.C701GiftBoxCart = {
    async checkChange(key, quantity) {
      const [cart, stock] = await Promise.all([readCart(), readStock()]);
      try { return core.checkChange({ cart, stock, key, quantity }); }
      catch (error) { error.cartQuantity = cart.items.find(item => item.key === key)?.quantity; throw error; }
    }
  };
  if (customElements.get('c701-giftbox-purchase')) return;
  customElements.define('c701-giftbox-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.error = this.querySelector('[data-gift-error]');
      this.link = this.querySelector('[data-review-cart]');
      this.selects = [...this.querySelectorAll('select[data-gift-choice]')];
      this.fields = [...this.querySelectorAll('select, input[name="quantity"]')];
      this.fields.forEach(field => { field.disabled = false; });
      this.button.disabled = false;
      this.form.addEventListener('submit', event => this.submit(event), { signal: this.controller.signal });
      this.form.addEventListener('change', () => { this.selects.forEach(select => { select.closest('.c701-gift__choice').querySelector('[data-scent-notes]').textContent = select.selectedOptions[0]?.dataset.notes || ''; }); }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    showError(message, mustReview = false) {
      this.error.textContent = message;
      this.error.hidden = false;
      this.link.hidden = !mustReview;
      if (mustReview) this.locked = true;
    }
    async submit(event) {
      event.preventDefault();
      if (this.busy || this.locked) return;
      this.error.hidden = true;
      this.link.hidden = true;
      if (!this.form.reportValidity()) return;
      this.busy = true;
      this.button.disabled = true;
      const selection = { parentId: this.dataset.parentId, quantity: this.form.elements.quantity.value, choices: this.selects.map(select => select.value) };
      this.fields.forEach(field => { field.disabled = true; });
      this.setAttribute('aria-busy', 'true');
      let before, payload, attempted = false, uncertain = false, serverMessage = '';
      try {
        const [cart, stock] = await Promise.all([readCart(), readStock()]);
        before = cart;
        payload = core.buildAdd({ ...selection, stock, cart });
        attempted = true;
        try {
          const response = await fetch(`${root}cart/add.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(payload) });
          const result = await response.json();
          if (!response.ok || result.status) serverMessage = typeof result.description === 'string' ? result.description : 'The gift box could not be added.';
        } catch (_) { uncertain = true; serverMessage = 'The add request could not be confirmed.'; }
        // A rejected add can still have changed the cart. Never repeat it automatically.
        let after;
        try { after = await readCart(); }
        catch (_) { this.showError('Please check your cart before trying again. We could not confirm whether this gift box was added.', true); return; }
        const outcome = core.reconcile(before, after, payload.items[0]);
        if (outcome.status === 'added') { this.locked = true; window.location.assign(`${root}cart`); return; }
        if (outcome.status === 'review') { this.showError('Your cart changed while this gift box was being added. Please review its quantities and scents before continuing.', true); return; }
        if (uncertain) { this.showError('Please check your cart before trying again. The add request could not be confirmed.', true); return; }
        this.showError(serverMessage || 'The gift box was not added. Please check your choices and try again.');
      } catch (error) {
        this.showError(attempted ? 'Please review your cart before trying again.' : error.message, attempted);
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        if (!this.locked) { this.fields.forEach(field => { field.disabled = false; }); this.button.disabled = false; }
      }
    }
  });
})();
